import React from 'react';
import { path, prop } from 'ramda';

import { Portal } from '@interlayer/js/app/components/system/Portal';
import { SvgIcon } from '@interlayer/js/app/components/common/SvgIcon';

import { TParcelProps } from './types';
import { useNavigate } from '@core/js/hooks/navigate';
import { clsx } from '@interlayer/js/app/utils/clsx.util';
import { tagTypeService } from '@core/js/services/tagType.service';
import { USER_PHASES } from '@interlayer/js/app/hooks/auth/constants';
import { useUserSelector, useAppSelector } from '@core/js/store/hooks';
import { TAG_TYPE_BUZZ } from '@interlayer/js/components/system/TagManager/buzz/constants';
import { useIsShowTag } from '@interlayer/js/components/system/App/buzz/hooks/useIsShowTag';
import { useShowAction } from '@interlayer/js/components/system/App/buzz/hooks/useShowAction';
import { BOTTOM_STICKY_IDS } from '@interlayer/js/app/components/system/BottomStickyElements/constants';

import style from './Parcel.scss';

export const Parcel: React.FC<TParcelProps> = ({ config }) => {
    const {
        shouldPulse,
        onlineUrl,
        multichannelUrl,
        backgroundColor = '#4ABAA9',
        defaultIconColor = '#ffffff'
    } = config;

    const navigate = useNavigate();
    const accountBusinessPhase = useUserSelector(path(['userDetails', 'accountBusinessPhase']));
    const isShowPlayBingoButton = useAppSelector(prop('isShowPlayBingoButton'));
    const isShowBottomMenu = useIsShowTag(TAG_TYPE_BUZZ.bottomNavigation);

    useShowAction(TAG_TYPE_BUZZ.parcelPromotion);

    const handleClick = () => {
        navigate(accountBusinessPhase === USER_PHASES.online ? onlineUrl : multichannelUrl);
    };

    return (
        <Portal id={BOTTOM_STICKY_IDS.parcel}>
            <div
                data-testid="Parcel_wrapper"
                style={{ backgroundColor }}
                className={clsx(style.wrapper, {
                    [style.withBottomMenuAndPlayButton]: isShowPlayBingoButton && isShowBottomMenu
                })}
            >
                {shouldPulse &&
                    Array.from({ length: 4 }, (_, i) => (
                        <div
                            data-testid="Parcel_wave"
                            key={i}
                            className={clsx(style.wave)}
                            style={{
                                background: `radial-gradient(ellipse at center, rgba(255,255,255,0) 0%, ${backgroundColor} 100%)`
                            }}
                        />
                    ))
                }

                <SvgIcon
                    type="gift"
                    color={defaultIconColor}
                    onClick={handleClick}
                    className={style.icon}
                />
            </div>
        </Portal>
    );
};

tagTypeService.registerTagType({ [TAG_TYPE_BUZZ.parcelPromotion]: Parcel });
